import { DataPrepConfiguration } from "fond/types";

export const DEFAULT_DATA_PREP_CONFIGURATION: DataPrepConfiguration = {
  CablePreference: "single_sided",
  IncludeMidStreetCrossings: false,
  IncludeServiceRoads: false,
  MinimizeDropCrossings: false,
};

/**
 * `architecture` with the default data prep configuration if it has none.
 */
export const withDefaultDataPrepConfiguration = <T extends { DataPrepConfiguration?: DataPrepConfiguration | null }>(architecture: T): T =>
  architecture.DataPrepConfiguration ? architecture : { ...architecture, DataPrepConfiguration: DEFAULT_DATA_PREP_CONFIGURATION };
